import ISelection from "../interfaces/ISelection";

export default function filterNumberSelections(selections: ISelection[]): ISelection[] {
    return selections.filter((selection: ISelection) => {
        const { outcome } = selection;
        if (!outcome) {
            return false;
        }
        if (outcome.name === "Keno Bonus") {
            return false;
        }

        return true;
    });
}



// WEBPACK FOOTER //
// ./src/utils/filterNumberSelections.ts